import React from 'react';
import styled from 'styled-components';
import RCore from 'RCore';
import UI from 'UI';
import { SimpleCard } from 'SportIcons';
import MatchScore from './MatchScore';
import PropTypes from 'prop-types';
import _ from 'lodash';

let i18dict = RCore.i18Register(require('../../../i18/i18.IncidentWidget.js'), {});
const i18 = RCore.getTranslation.bind({ dict: i18dict });

const Wrapper = styled.div`
    height: 380px;
    text-align: center;
`;

const GoalTitle = styled.div`
    color: ${props => props.theme.titleColor || props.theme.color};
    font-weight: 700;
    font-size: 64px;
    line-height: 69px;
    font-weight: 700;
    margin-bottom: 21px;
    padding-top: 10px;
`;

const MatchScoreWrapper = styled.div`
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
`;

const SubstitutionTitle = styled.div`
    color: ${props => props.theme.titleColor || props.theme.color};
    font-weight: 700;
    font-size: 48px;
    line-height: 69px;
    font-weight: 700;
    margin-bottom: 54px;
    padding-top: 10px;
    text-transform: uppercase;
`;

const CardTitle = SubstitutionTitle.extend`
    margin-bottom: 21px;
`;

const PlayerInfo = styled.div`
    color: ${props => props.theme.color};
    font-size: 24px;
    line-height: 27px;
    line-height: 1;
    margin: 0;
    text-transform: uppercase;
`;

const PlayerName = styled.div``;

const SubstitutedPlayers = styled.div`
    width: 100%;
    text-align: left;
    padding: 0 20px;
    box-sizing: border-box;
`;

const SubstitutedPlayerWrapper = styled.div`
    position: relative;
    font-size: 25px;
    color: ${props => props.theme.color};
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    .sm-substituted-player__name-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .sm-substituted-player__info {
        width: calc(100% - 131px); 
        background: ${props => props.theme.content.backgroundColor};
        
        padding: 6px 10px 6px 20px;
        box-sizing: border-box;
    }
    > div {
        display: inline-block;
        vertical-align: middle;
    }
    .sm-substituted-player__icon {
        width: 44px;
        margin-right: 10px;
        img {
            width: 100%;
            height: auto;
        }
    }
    .sm-substituted-player__photo {
        height: 80px;
        width: 80px;
        margin-right: 10px;
        margin-bottom: 0;
        margin-left: 0;
        display: inline-block;
        vertical-align: middle;
    }
    .sm-substituted-player__number {
        width: 131px;
        font-size: 48px;
        line-height: 92px;
        padding-right: 48px;
        box-sizing: border-box;
        text-align: right;
        font-weight: 700;
        background: ${props => props.theme.content.backgroundColor};
        position: relative;
        &_in {
            color: ${props => props.theme.positiveColor};
        }
        &_out {
            color: ${props => props.theme.substitutionOutColor};
        }
        
        .sm-substituted-player__icon_in,
        .sm-substituted-player__icon_out {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translate(0, -50%);
            width: 0;
            height: 0;
            border-style: solid;
        }
        
        .sm-substituted-player__icon_in {
            border-width: 14px 0 14px 22px;
            border-color: transparent transparent transparent currentColor;
        }
        
        .sm-substituted-player__icon_out {
            border-width: 14px 22px 14px 0;
            border-color: transparent currentColor transparent transparent;
        }
    }
    .sm-substituted-player__name {
    width: calc(100% - 90px);
        text-align: left;
        color: ${props => props.theme.color};
        font-size: 24px;
        line-height: 27px;
        font-weight: 700;
        text-transform: uppercase;
        display: inline-block;
        vertical-align: middle;
}
    }
`;

const CardWrapper = styled.div`
    .sm-card {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
        position: absolute;
        transform: rotate(15deg) translate(10%, -50%);
        top: 50%;
        right: 0;
    }
`;

const PlayerLastName = styled.div`
    font-weight: 700;
    font-size: 40px;
    line-height: 40px;
    font-weight: 700;
`;

const PlayerPhotoWrapper = styled.div`
    position: relative;
    display: inline-block;
`;

const PlayerPhoto = styled.div`
    width: 160px;
    height: 160px;
    border-radius: 50%;
    margin: 0 auto 22px;
    overflow: hidden;
    background-color: ${props => props.theme.logosBackground};
    position: relative;
    img {
        height: auto;
        width: 100%;
        ${props =>
            props.isJersey
                ? `
       width: 80%;
       height: auto;
       margin: auto;
       position: absolute;
       top: 50%;
       left: 50%;
       transform: translate(-50%, -50%);
       `
                : ''};
    }
`;

const IncidentMinute = styled.div`
    ${props => `color: ${props.incidentMinuteColor};`} text-align: center;
    width: 100%;
    font-size: 64px;
    line-height: 69px;
    font-weight: 700;
    padding-top: 10px;
`;

const Incident = styled.div`
    text-transform: uppercase;
    .player {
        font-size: 34px;
    }
    .ic-player__surname {
        font-size: 36px;
        font-weight: bold;
    }
`;

const Player = ({ teamId, player, card, event }) => {
    let name = RCore.getFirstLastName(player.name);
    return (
        <PlayerInfo>
            <PlayerPhotoWrapper>
                <PlayerPhoto isJersey={!RCore.hasCDNPlayerLogos(event.tournamentId)}>
                    <UI.PlayerLogo
                        className="wdp-player-stats__header-teamlogo"
                        display="image"
                        size="large"
                        playerId={player.id}
                        seasonId={event.tournamentId}
                        teamId={teamId}
                    />
                </PlayerPhoto>
                {card}
            </PlayerPhotoWrapper>

            <PlayerName>
                {player.shirtNumber ? `${player.shirtNumber}.` : null} {`${name.firstName || ''}`}
            </PlayerName>
            <PlayerLastName>{`${name.lastName || ''}`}</PlayerLastName>
        </PlayerInfo>
    );
};

const Goal = (props, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');
    return (
        <Incident>
            <GoalTitle>{i18('title.goal', lang)}</GoalTitle>
            <Player {...props} teamId={props.incident.teamId} />
        </Incident>
    );
};

const Assist = (props, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');
    return (
        <Incident>
            <GoalTitle>{i18('title.assist', lang)}</GoalTitle>
            <Player {...props} teamId={props.incident.teamId} />
        </Incident>
    );
};

const OwnGoal = (props, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');
    // swap team id, as incident teamId shows who will get a score
    let teamId = props.incident.teamId === props.event.homeId ? props.event.awayId : props.event.homeId;

    return (
        <Incident>
            <GoalTitle>{i18('title.owngoal', lang)}</GoalTitle>
            <Player {...props} teamId={teamId} />
        </Incident>
    );
};

const Card = (props, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');
    let card = (
        <CardWrapper>
            <SimpleCard width={58} height={76} radius="3" color={props.cardColor} />
        </CardWrapper>
    );
    return (
        <Incident>
            <CardTitle>{i18(`title.${props.cardName}`, lang)}</CardTitle>
            <Player {...props} teamId={props.incident.teamId} card={card} />
        </Incident>
    );
};

const SubstitutedPlayer = ({ player, teamId, type, event }) => {
    if (!player) return null;
    let name = RCore.getFirstLastName(player.name);

    return (
        <SubstitutedPlayerWrapper>
            <div className={`sm-substituted-player__number sm-substituted-player__number_${type}`}>
                {player.shirtNumber || '-'}
                <span className={`sm-substituted-player__icon_${type}`} />
            </div>
            <div className="sm-substituted-player__info">
                <PlayerPhoto
                    isJersey={!RCore.hasCDNPlayerLogos(event.tournamentId)}
                    className="sm-substituted-player__photo"
                >
                    <UI.PlayerLogo
                        display="image"
                        size="large"
                        playerId={player.id}
                        seasonId={event.tournamentId}
                        teamId={teamId}
                    />
                </PlayerPhoto>
                <div className="sm-substituted-player__name">
                    <div className="sm-substituted-player__name-wrapper">
                        <span className="sm-substituted-player__name__inner">{name.firstName}</span>
                    </div>
                    <div className="sm-substituted-player__name-wrapper">
                        <span className="sm-substituted-player__name__inner">{name.lastName}</span>
                    </div>
                </div>
            </div>
        </SubstitutedPlayerWrapper>
    );
};

const Substitution = ({ event, incident, player, player2 }, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');
    return (
        <Incident>
            <SubstitutionTitle>{i18('title.subs', lang)}</SubstitutionTitle>
            <SubstitutedPlayers>
                <SubstitutedPlayer player={player} event={event} teamId={incident.teamId} type={'in'} />
                <div style={{ height: '10px' }} />
                <SubstitutedPlayer event={event} player={player2} teamId={incident.teamId} type={'out'} />
            </SubstitutedPlayers>
        </Incident>
    );
};

const Preview = (props, ctx) => {
    const { event, incidentId, matchScore, incidentMinuteColor, incidentMinute } = props;
    return (
        <div>
            <IncidentMinute incidentMinuteColor={incidentMinuteColor}>{incidentMinute}'</IncidentMinute>

            <MatchScoreWrapper>
                <MatchScore
                    {...matchScore}
                    event={event}
                    view="nameScore"
                    styles={`font-size: 32px;`}
                    incidentId={incidentId}
                />
            </MatchScoreWrapper>
        </div>
    );
};

Goal.contextTypes = {
    info: PropTypes.object
};

Wrapper.contextTypes = {
    info: PropTypes.object
};
Assist.contextTypes = {
    info: PropTypes.object
};
OwnGoal.contextTypes = {
    info: PropTypes.object
};
Card.contextTypes = {
    info: PropTypes.object
};
Preview.contextTypes = {
    info: PropTypes.object
};
Substitution.contextTypes = {
    info: PropTypes.object
};

export default {
    Preview,
    Wrapper,
    Goal,
    Assist,
    OwnGoal,
    Card,
    Substitution
};
export { Preview, Wrapper, Goal, Assist, OwnGoal, Card, Substitution };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/IncidentWithPhotos.js
 **/